module.exports = __webpack_public_path__ + "img/2.bbb64025.png";